import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { withLocale } from "~/lib/utils/with-locale";

export const Route = createFileRoute("/_login")({
  component: RouteComponent,
});

/** Shared layout for login/sign-up pages. Used by both _login and __main/$locale routes. */
export function LoginLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div className="fixed bg-white lg:bg-transparent top-0 left-0 right-0 z-50 layout-content-grid max-w-(--layout-page-max-width) mx-auto">
        <div className="layout-place-outer-wrap">
          <Link to={withLocale("/")}>
            <img
              src="/logo-black.svg"
              alt="logo"
              className="h-11 w-auto my-4"
            />
          </Link>
        </div>
      </div>
      <div className="grid lg:grid-cols-2 items-center min-h-screen pt-(--top-panel-height) pb-6 lg:py-0">
        {children}
        <img
          src="/temp/login-image.jpg"
          alt=""
          className="object-cover w-full h-screen hidden lg:block"
        />
      </div>
    </>
  );
}

function RouteComponent() {
  return (
    <LoginLayout>
      <Outlet />
    </LoginLayout>
  );
}
